import { Pipe, PipeTransform } from '@angular/core';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { MailingTypeEnum } from '@zaoblako/shared/modules/notification/enums/mailing.type.enum';
import { MailingTypeEnumI18n } from '@zaoblako/shared/modules/notification/i18n/mailing.type.enum.i18n';

@Pipe({
  standalone: true,
  name: 'mailingTypeName'
})
export class MailingTypeNamePipe implements PipeTransform {
  public transform(type: MailingTypeEnum): string {
    return MailingTypeEnumI18n?.[I18nLocalesEnum.RU_RU]?.[type] || '';
  }
}
